import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@reduxjs/toolkit';
import PropTypes from 'prop-types';
import { Button } from '@beef/ui-kit';
import classNames from 'classnames/bind';

import { showMoreProducts } from 'store/ProductCatalog/actions';
import {
  selectCatalogShowMoreLoading,
  selectIsShowMoreVisible,
} from 'store/ProductCatalog/products/selectors';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const BUTTON_TITLE = 'Показать еще';

const _DeviceButton = ({ onClick, isLoading }) => (
  <div className={cx('component')}>
    <Button
      onClick={onClick}
      fullWidth
      variant="tertiary"
      size="m"
      isLoading={isLoading}
      disabled={isLoading}
    >
      {BUTTON_TITLE}
    </Button>
  </div>
);

_DeviceButton.propTypes = {
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  shouldRender: selectIsShowMoreVisible(state),
  isLoading: selectCatalogShowMoreLoading(state),
});

const mapDispatchToProps = {
  onClick: showMoreProducts,
};

export const DeviceButton = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRenderFlag,
)(_DeviceButton);
